import { useQuery, gql } from '@apollo/client';

import { AbstractCategory } from 'utils/graphql/categories';

type L2Category = AbstractCategory;

type L2CategoriesData$Props = {
  topCategoryList: L2Category[];
};

const l2CategoriesQuery = gql`
  query TopCategoryList {
    topCategoryList(showHiddenCategories: false) {
      id
      name
      slug
    }
  }
`;

export const useL2Categories = () => useQuery<L2CategoriesData$Props>(l2CategoriesQuery);
